import moment from "moment-timezone";

const DAY_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/** Clients under moment.locale("ar") may send Eastern/Persian digits. */
function toLatinDigits(value: string) {
  return value
    .replace(/[\u0660-\u0669]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[\u06f0-\u06f9]/g, (d) => String(d.charCodeAt(0) - 0x06f0));
}

/** Event-timezone midnight → UTC Date range for DB queries. */
export function getDayUtcRange(day: string, timezone: string) {
  const start = moment.tz(day, "YYYY-MM-DD", timezone).startOf("day").toDate();
  const end = moment.tz(day, "YYYY-MM-DD", timezone).endOf("day").toDate();
  return { start, end };
}

/**
 * Prefer `YYYY-MM-DD`. Legacy ISO datetimes (local-midnight toISOString)
 * are converted to the calendar day in `timezone`.
 */
export function normalizeDayParam(
  day: string | null | undefined,
  timezone: string
): string | undefined {
  if (!day) return undefined;
  const trimmed = toLatinDigits(day.trim());
  // moment("Invalid date") warns and is never a real day — drop it.
  if (!trimmed || /invalid/i.test(trimmed)) return undefined;
  if (DAY_ONLY.test(trimmed)) return trimmed;
  if (!/\d/.test(trimmed)) return undefined;
  const m = moment(trimmed);
  if (!m.isValid()) return undefined;
  return m.tz(timezone).locale("en").format("YYYY-MM-DD");
}
